<template>
  <WishList :config="config" />
</template>

<script>
import WishList from "../../components/WishList/WishList.vue";

export default {
  name: "app",
  components: {
    WishList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
